var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cartCount)?_c('span',{staticClass:"counter leading-none absolute bottom-0 left-0 -mb-2 -ml-2 p-1 text-xs text-white bg-primary-600 rounded-full flex justify-center items-center"},[_vm._v("\n  "+_vm._s(_vm.cartCount)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }